import styled from 'styled-components';

import { VerticalCenterBlock } from '../../../styled';

export const Wrapper = styled.div`
  border: 1px solid rgba(0, 36, 77, 0.05);
  box-shadow: 0 4px 8px rgba(0, 36, 77, 0.08);
  box-sizing: border-box;
  border-radius: 8px;
  padding: 24px;
  height: 100%;
`;

export const StatisticsWrapper = styled(VerticalCenterBlock)`
  gap: 20px;

  @media screen and (max-width: 1000px) {
    gap: 10px;
  }
`;

export const Title = styled.div`
  ${(p) => p.theme.typography.accent};
  margin: 8px 0 28px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ProjectIDWrapper = styled.span`
  ${(p) => p.theme.typography.body};
  width: min-content;
  font-size: 11px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 5px;

  :hover {
    color: ${(p) => p.theme.colors.brand};
  }
`;

export const ProjectIDText = styled.span`
  font-weight: bold;
`;
